(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchReportMaterialCategoryDialogController', PatchReportMaterialCategoryDialogController);

    PatchReportMaterialCategoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PatchReportMaterialCategory'];

    function PatchReportMaterialCategoryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PatchReportMaterialCategory) {
        var vm = this;
        vm.patchReportMaterialCategory = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:patchReportMaterialCategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.patchReportMaterialCategory.id !== null) {
                PatchReportMaterialCategory.update(vm.patchReportMaterialCategory, onSaveSuccess, onSaveError);
            } else {
                PatchReportMaterialCategory.save(vm.patchReportMaterialCategory, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
